import { getPermissionRegistry } from "@constants";
import { usePermissions } from "@pionglobal/pionsharedui";
import { useMemo } from "react";
import { useHostSelector } from "./useHostState";

export const useApplicationPermissions = (
  appName,
  moduleName,
  featureName,
  specific,
) => {
  const permissionSet = useHostSelector((state) => state?.permissions?.data);

  const permissionValue = useMemo(() => {
    return getPermissionRegistry(appName, moduleName, featureName, specific);
  }, [appName, moduleName, featureName, specific]);

  return usePermissions(permissionSet, permissionValue);
};
